import { render, staticRenderFns } from "./ProfilSettings.vue?vue&type=template&id=22f2097f"
import script from "./ProfilSettings.vue?vue&type=script&lang=js"
export * from "./ProfilSettings.vue?vue&type=script&lang=js"
import style0 from "./ProfilSettings.vue?vue&type=style&index=0&id=22f2097f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports